import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { AuthService } from "../services/api/auth/auth.service";
import { environment } from "../../environments/environment";

export const demoModeGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const checkAlloWDemoAccess = () => {
    const mode = route.queryParams["mode"] || null;
    const decoded = authService.getDecodedToken();
    const isInternal =
      !environment.production && (decoded["isInternal"] || false);
    const isManager = decoded["role"] === "MANAGER";
    if (mode === "demo" && !(isInternal && isManager)) {
      return false;
    }
    return true;
  };

  // Check whether the user is in demo mode and has access
  if (checkAlloWDemoAccess()) {
    return true;
  }
  const cleanTree = router.parseUrl(state.url);
  delete cleanTree.queryParams["mode"];
  return cleanTree;
};
